import React, { createContext, useState, useContext } from 'react';
import { applicationTabs } from '../helper/applicationTabs';

const ApplicationContext = createContext();

export const useApplicationContext = () => useContext(ApplicationContext);

export const ApplicationProvider = ({ children }) => {
  // Default to the first tab's ID
  const [activeTabId, setActiveTabId] = useState(applicationTabs[0].id);

  return (
    <ApplicationContext.Provider value={{ activeTabId, setActiveTabId }}>
      {children}
    </ApplicationContext.Provider>
  );
};
